import PropTypes from 'prop-types'

import { UserAvatarContainer } from '../../styled-components.js'
import { statusIndicationMemberOptions } from '../../../../atoms/status-indication/constants.js'
import { iconSizeOptions } from '../../../../atoms/icons/icons-sizes.js'
import StatusIndicationComponent from '../../../../atoms/status-indication/index.jsx'
import colorsOptions from '../../../../fundamentals/colors-styles/constants.js'

const UserAvatar = ({ profilePicture, status }) => {
  return (
    <UserAvatarContainer>
      <StatusIndicationComponent
        status={status}
        size={iconSizeOptions['ICON-M']}
        image={profilePicture}
        iconColor={colorsOptions.greys.white}
      />
    </UserAvatarContainer>
  )
}

UserAvatar.propTypes = {
  profilePicture: PropTypes.string,
  status: PropTypes.oneOf(Object.values(statusIndicationMemberOptions))
}

export default UserAvatar
